(function () {
  const fallbackSrc = window.__amImageFallbackSrc;
  if (!fallbackSrc) return;

  const BAD_SRC_PATTERNS = [/liquid%20error/i, /invalid%20url%20input/i, /undefined/i, /null/i];

  function hasBadSource(img) {
    const src = (img.getAttribute('src') || '').trim();
    if (!src) return true;
    return BAD_SRC_PATTERNS.some((pattern) => pattern.test(src));
  }

  function applyFallback(img) {
    if (!(img instanceof HTMLImageElement)) return;
    if (img.dataset.amFallbackApplied === 'true') return;

    img.dataset.amFallbackApplied = 'true';
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = fallbackSrc;
  }

  function inspectImage(img) {
    if (!(img instanceof HTMLImageElement)) return;
    if (hasBadSource(img)) {
      applyFallback(img);
      return;
    }

    if (img.complete && img.naturalWidth === 0) {
      applyFallback(img);
    }
  }

  function scanAllImages(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('img').forEach(inspectImage);
  }

  document.addEventListener(
    'error',
    (event) => {
      if (event.target instanceof HTMLImageElement) {
        applyFallback(event.target);
      }
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      scanAllImages(document);
    });
  } else {
    scanAllImages(document);
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.tagName === 'IMG') inspectImage(node);
        scanAllImages(node);
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
